import FirmaContratoComponent from "../components/FirmaContrato/Index.jsx";

/**
 * Página para la firma de contrato del invitado
 * Wrapper simple que renderiza el componente FirmaContrato
 */
export default function FirmaContrato() {
  return <FirmaContratoComponent />;
}
